<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>PLAYER INSTANCE ANALYTICS</span>
        </div>
        <div class="header-sub-title">
          <span>{{ instance.general.name }}</span>
        </div>
      </div>
      <div class="" v-loading="loadingGet">
        <el-tabs tab-position="left">
          <el-tab-pane label="Launches Daily">

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'InstanceAnalytics',
  components: {
  },
  data () {
    return {
      instanceId: this.$route.params.id,
      instance: { general: {} },
      loadingGet: false
    }
  },
  created () {
    this.getInstance()
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      currentRole: 'currentRole'
    })
  },
  watch: {
  },
  methods: {
    getInstance: function () {
      if (this.loadingGet) return
      this.loadingGet = true
      const rolePath = this.currentRole === 'client' ? '' : '/admin'
      const url = `/api/v1/atk_player${rolePath}/instances/${this.instanceId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instance = res.data
        } else {
          console.error('getInstance', res.msg)
        }
        that.loadingGet = false
      }).catch(function (err) {
        console.error('getInstance', err.msg)
        that.loadingGet = false
      })
    }
  }
}
</script>

<style lang="scss">
</style>
